/*
*
* Aml Api
*
* @version 1.0.0
* @author Giorgia Cuozzo
* @since 03-Jun-2025
*/

import { Capacitor } from '@capacitor/core'
import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'
if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/aml/aml')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}

export async function getSurvey (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/public/aml/survey',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getDocumentTypes (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/public/aml/document-types',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getDocumentIssuers (params) {
  let data
  const documentType = params?.documentType

  try {
    data = await axios({
      method: 'get',
      url: `/services/merchant-service/public/aml/document-issuers/${documentType}`
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getLegalForms (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `/services/merchant-service/public/aml/legal-forms?fiscalCode=${params.fiscalCode}`,
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getNoProfitOrganizations (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/public/aml/no-profit-organizations',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getOnlusClasses (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/public/aml/onlus-classes',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getLegalRelations (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/public/aml/legal-relations',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getSaeCode (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/public/aml/sae',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getAteco (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `/services/merchant-service/public/aml/ateco-codes/${params.saeCode}`,
      data: {}
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function postSurvey (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/public/aml/survey',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function postDownloadSurvey (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/public/aml/download',
      data: { ...params },
      responseType: 'arraybuffer'
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function saveUploadDocuments (params) {
  let data

  const body = new FormData()
  const payload = params.files

  if (Capacitor.isNativePlatform()) {
    const mobileArray = []
    for (let i = 0; i < payload.length; i++) {
      const ArrayByte = []
      for (const [key, value] of Object.entries(payload[i].file.data)) {
        ArrayByte.push(0)
        ArrayByte[parseInt(key)] = value
      }
      const mobileBody = {
        name: payload[i].name,
        amlIdentityDocumentType: payload[i].amlIdentityDocumentType,
        amlRepresentativeType: payload[i].amlRepresentativeType,
        file: null,
        bytes: ArrayByte,
        contentType: payload[i].file.mediaType
      }
      mobileArray.push(mobileBody)
    }

    try {
      data = await axios({
        method: 'post',
        url: '/services/merchant-service/public/aml/v2/personal-docs',
        data: { amlIdentityDocuments: mobileArray }
      })
      return handlingResponse(data)
    } catch (error) {
      return handlingResponse(error)
    }
  } else {
    for (let i = 0; i < payload.length; i++) {
      const item = payload[i]
      body.append(`amlIdentityDocuments[${i}].amlRepresentativeType`, String(item.amlRepresentativeType || ''))
      body.append(`amlIdentityDocuments[${i}].amlIdentityDocumentType`, String(item.amlIdentityDocumentType || ''))
      body.append(`amlIdentityDocuments[${i}].name`, String(item.name || ''))

      if (item.file && item.file instanceof File) {
        body.append(`amlIdentityDocuments[${i}].file`, item.file)
      }
    }

    try {
      data = await axios({
        method: 'post',
        url: '/services/merchant-service/public/aml/personal-docs',
        data: body,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      for (const [k, v] of body.entries()) {
        console.log(k, v)
      }
      return handlingResponse(data)
    } catch (error) {
      return handlingResponse(error)
    }
  }
}

export async function getBeneficialRelations (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/public/aml/beneficial-relations',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
